// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__21GM4","legacyBtn":"MutateMid_legacyBtn__1Xh_e"};